import React from 'react';
import './PharmacyReceipt.css'; // You'll add styles below
import { dateTimeFormatter, dateTimeFormatter2 } from '../Utils/DateTimeFormatter';

const PharmacyReceipt = React.forwardRef(({ invoice, patient, prescribedMedicines }, ref) => {
    const {
        invoiceId,
        invoiceTime,
        invoiceName,
        invoiceDescription,
        totalAmount,
        amountPaid,
        payments,
        patientName,
        patientMRNo,
        patientAge,
        patientGender,
        phoneNumber,
        doctorName,
        appointmentTime,
        tokenNo,
        createdBy,
        printedBy,
    } = invoice;
    console.log(prescribedMedicines);
    return (
        <div className="receipt-container" ref={ref}>
            {/* Header */}
            <div className="receipt-header">
                <img src="/VThospitalsLogo.png" alt="Logo" className="logo" />
                <h2 className="clinic-name">VISWATEJA HOSPITAL & DIAGNOSTIC CENTRE</h2>
                <p className="clinic-address">26-4-788/1, RPGT Road, Near Srinivasa Talkies, Hindupur - 515201</p>
            </div>
             
            <div className="header-info">
                <span><strong>GSTIN : 37BISPR5832E1ZR</strong> </span>
                <span><strong>DLNO. : AP/12/02/2019-3718, AP/12/02/2019-3719</strong></span>
            </div>

            {/* Patient & Appointment Info */}
            <table className="info-table">
                <tbody>
                    <tr>
                        <td>Patient Name: </td>
                        <td><strong>{patient.patientName} </strong></td>

                        <td>MR No:</td>
                        <td><strong>{patient.mrNumber} </strong></td>
                    </tr>
                    <tr>
                        <td>Age/Gender: </td>
                        <td><strong>{patient.age} / {patient.gender} </strong></td>

                        <td>Date:</td>
                        <td>{dateTimeFormatter(patient.prescriptionDate, patient.prescriptionTime)}</td>
                    </tr>

                    <tr>
                        <td>Doctor: </td>
                        <td>{patient.doctorName}</td>

                        <td>Invoice No:</td>
                        <td><strong>{invoiceId} </strong></td>
                    </tr>


                </tbody>
            </table>

            {/* Items Table */}
            <table className="items-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Particulars</th>
                        <th>HSN</th>
                        <th>Qty</th>
                        <th>Batch</th>
                        <th>Expiry</th>
                        <th>MRP</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {prescribedMedicines && prescribedMedicines.length > 0 ? (
                        prescribedMedicines.map((prescribedMedicine, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{(prescribedMedicine.medicineBrand || '') + (prescribedMedicine.composition ? ` (${prescribedMedicine.composition})` : '')}</td>
                                <td>{prescribedMedicine.hsnCode}</td>
                                <td>{prescribedMedicine.quantity}</td>
                                <td>{prescribedMedicine.batch}</td>
                                <td>{prescribedMedicine.expiryDate}</td>
                                <td>₹{(prescribedMedicine.quantity ? (prescribedMedicine.price / prescribedMedicine.quantity).toFixed(2) : '0.00')}</td>
                                {/* <td>₹{(prescribedMedicine.price) / (prescribedMedicine.quantity)}</td> */}
                                <td>₹{prescribedMedicine.price}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" style={{ textAlign: 'center' }}>
                                No invoice items available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Amount Summary */}
            <div className="amount-summary">
                <div><strong>Total Amount:</strong> ₹{totalAmount}</div>
                <div><strong>Paid Amount:</strong> ₹{amountPaid}</div>
                <div><strong>Balance:</strong> ₹{totalAmount - amountPaid}</div>
            </div>

            {/* Payment Details */}
            <h3 className="section-heading">Payment Details</h3>
            <table className="receipt-details-table">
                <thead>
                    <tr>
                        <th>Payment ID</th>
                        <th>Date/Time</th>
                        <th>Transaction Type</th>
                        <th>Mode</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {payments?.map((pmt, i) => (
                        <tr key={i}>
                            <td>{pmt.paymentId}</td>
                            <td>{new Date(pmt.paymentDate).toLocaleString()}</td>
                            <td>{pmt.paymentMode}</td>
                            <td>{pmt.paymentMode}</td>
                            <td>₹{pmt.amount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>


            {/* PayInvoice Details */}
            <h3 className="section-heading">Invoice Details</h3>
            <table className="receipt-details-table">
                <thead>
                    <tr>
                        <th>Invoice ID</th>
                        <th>Invoice Date/Time</th>
                        <th>Invoice Amount</th>
                    </tr>
                </thead>
                <tbody>

                    <td>{invoice.invoiceId}</td>
                    <td>{dateTimeFormatter2(invoice.invoiceTime)}</td>
                    <td>₹{invoice.totalAmount}</td>

                </tbody>
            </table>
            <strong>Note: Goods once sold can be returned or exchanged only within 30 days of purchase.</strong>
            {/* Footer */}
            <div className="footer-info">

                <span><strong>Printed By:</strong> {printedBy || "System"}</span>
                <span><strong>Created By:</strong> {createdBy || "Admin"}</span>
            </div>
        </div>
    );
});

export default PharmacyReceipt;
